<!-- eslint-disable vue/valid-v-slot -->
<template>
    <div>
        <v-data-table :headers="headers" :items="desserts" sort-by="Numero_Turno" class="elevation-1 notranslate" translate="no" :search="search"
            multi-sort :dark="$vuetify.theme.dark">
            <template v-slot:top>
                <v-overlay :value="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-overlay>
                <v-snackbar v-model="NotiExito" :timeout="3000" color="success" top right>
                    {{ notiMessage }}
                    <template v-slot:action="{ attrs }">
                        <v-btn text v-bind="attrs" @click="NotiExito = false">
                            Cerrar
                        </v-btn>
                    </template>
                </v-snackbar>
                <div class="table-toolbar">
                  <span class="table-toolbar__title">Turnos</span>
                  <div class="table-search-wrap">
                    <v-icon small color="rgba(255,255,255,0.4)">mdi-magnify</v-icon>
                    <input v-model="search" type="text" class="table-search" placeholder="Buscar..." />
                  </div>
                </div>
            </template>
            <template v-slot:item.Nombre_Cargador="{ item }"><span v-text="item.Nombre_Cargador"></span></template>
            <template v-slot:item.Altura="{ item }"><span v-text="item.Altura"></span></template>
            <template v-slot:item.Numero_Turno="{ item }"><span v-text="item.Numero_Turno"></span></template>
            <template v-slot:item.Numero_Brazo="{ item }"><span v-text="item.Numero_Brazo"></span></template>
            <template v-slot:item.Documento_Identificacion="{ item }"><span v-text="item.Documento_Identificacion"></span></template>
            <template v-slot:item.Fecha_Inscripcion="{ item }"><span v-text="item.Fecha_Inscripcion"></span></template>
            <template v-slot:item.No_Recibo="{ item }"><span v-text="item.No_Recibo"></span></template>
            <template v-slot:item.Mesa="{ item }"><span v-text="item.Mesa"></span></template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
        <!-- Dialog de sesión expirada -->
        <v-dialog v-model="showSessionExpiredDialog" max-width="400">
        </v-dialog>
    </div>
</template>

<script>



export default {
    props: {
        Turnos: [],
    },
    watch: {
        Turnos: {
            immediate: true,
            handler(newValue) {
                if (newValue && newValue.length > 0) {
                    this.initialize();
                }
            }
        }
    },
    data: () => ({
        showSessionExpiredDialog: false,
        loading: false,
        NotiExito: false,
        notiMessage: "",
        search: '',
        validToken: false,
        headers: [
            { text: 'Cargador', align: 'start', sortable: false, value: 'Nombre_Cargador' },
            { text: 'Altura', value: 'Altura' },
            { text: 'Turno', value: 'Numero_Turno' },
            { text: 'Brazo', value: 'Numero_Brazo' },
            { text: 'Identificación', value: 'Documento_Identificacion' },
            { text: 'Fecha de Inscripcion', value: 'Fecha_Inscripcion' },
            { text: 'No. Recibo', value: 'No_Recibo' },
            { text: 'Mesa', value: 'Mesa' },
        ],
        desserts: [{
            "Nombre_Cargador": "Cargador 1",
            "Altura": 1.40,
            "Numero_Turno": 1,
            "Numero_Brazo": 1,
            "Documento_Identificacion": "000000000000",
            "Fecha_Inscripcion": "2024-01-01T00:00:00.000Z",
            "No_Recibo": 0,
            "Mesa": 0,
        },],
    }),
    created() {
        this.initialize()
    },
    methods: {

        redirectToLogin() {
            // Redirigir al usuario al componente de inicio de sesión
            // localStorage.removeItem('token');
            // localStorage.removeItem('user');
            // localStorage.removeItem('username');
            // localStorage.removeItem('name');
            const allCookies = this.$cookies.keys();
            for (const cookie of allCookies) {
                this.$cookies.remove(cookie);
            }

            this.$router.push('/sistema');
        },
        clearAllCookies() {
            const allCookies = this.$cookies.keys();
            for (const cookie of allCookies) {
                this.$cookies.remove(cookie);
            }
        },
        hideNotification() {
            // Logic handled by v-snackbar automatically
        },
        initialize() {
            this.desserts = this.Turnos
        }

    }
}
</script>

<style scoped>
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
  background: var(--sys-card-bg);
  border-bottom: 1px solid var(--sys-card-border);
  font-family: 'Inter', sans-serif;
}
.table-toolbar__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--sys-text-primary);
}
.table-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--sys-input-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 8px;
  padding: 7px 14px;
  transition: border-color 0.2s;
}
.table-search-wrap:focus-within { border-color: rgba(123,47,247,0.6); }
.table-search {
  background: transparent;
  border: none;
  outline: none;
  color: var(--sys-text-primary);
  font-family: 'Inter', sans-serif;
  font-size: 0.88rem;
  width: 160px;
}
.table-search::placeholder { color: var(--sys-text-secondary); }
</style>